// namespace
export const NAMESPACE = "settings";

// actions
export const SET_THEME = "SET_THEME";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_SHOW_NOTICE = "SET_SHOW_NOTICE";
